"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var DOMException = require("domexception");

var attrGenerated = require("./generated/Attr");

var _require = require("./helpers/strings"),
    asciiLowercase = _require.asciiLowercase;

var _require2 = require("./helpers/namespaces"),
    HTML_NS = _require2.HTML_NS; // The following three are for https://dom.spec.whatwg.org/#concept-element-attribute-has. We don't just have a
// predicate tester since removing that kind of flexibility gives us the potential for better future optimizations.


exports.hasAttribute = function (element, A) {
  return element._attributeList.includes(A);
};

exports.hasAttributeByName = function (element, name) {
  return element._attributesByNameMap.has(name);
};

exports.hasAttributeByNameNS = function (element, namespace, localName) {
  return element._attributeList.some(function (attribute) {
    return attribute._localName === localName && attribute._namespace === namespace;
  });
};

exports.changeAttribute = function (element, attribute, value) {
  // https://dom.spec.whatwg.org/#concept-element-attributes-change
  var oldValue = attribute._value;
  attribute._value = value; // Run jsdom hooks; roughly correspond to spec's "An attribute is set and an attribute is changed."

  element._attrModified(attribute._qualifiedName, value, oldValue);
};

exports.appendAttribute = function (element, attribute) {
  // https://dom.spec.whatwg.org/#concept-element-attributes-append
  var attributeList = element._attributeList; // TODO mutation observer stuff

  attributeList.push(attribute);
  attribute._element = element; // Sync name cache

  var name = attribute._qualifiedName;
  var cache = element._attributesByNameMap;
  var entry = cache.get(name);

  if (!entry) {
    entry = [];
    cache.set(name, entry);
  }

  entry.push(attribute); // Run jsdom hooks; roughly correspond to spec's "An attribute is set and an attribute is added."

  element._attrModified(name, attribute._value, null);
};

exports.removeAttribute = function (element, attribute) {
  // https://dom.spec.whatwg.org/#concept-element-attributes-remove
  var attributeList = element._attributeList; // TODO mutation observer stuff

  for (var i = 0; i < attributeList.length; ++i) {
    if (attributeList[i] === attribute) {
      attributeList.splice(i, 1);
      attribute._element = null; // Sync name cache

      var name = attribute._qualifiedName;
      var cache = element._attributesByNameMap;
      var entry = cache.get(name);
      entry.splice(entry.indexOf(attribute), 1);

      if (entry.length === 0) {
        cache.delete(name);
      } // Run jsdom hooks; roughly correspond to spec's "An attribute is removed."


      element._attrModified(name, null, attribute._value);

      return;
    }
  }
};

exports.replaceAttribute = function (element, oldAttr, newAttr) {
  // https://dom.spec.whatwg.org/#concept-element-attributes-replace
  var attributeList = element._attributeList; // TODO mutation observer stuff

  for (var i = 0; i < attributeList.length; ++i) {
    if (attributeList[i] === oldAttr) {
      attributeList.splice(i, 1, newAttr);
      oldAttr._element = null;
      newAttr._element = element; // Sync name cache

      var name = newAttr._qualifiedName;
      var cache = element._attributesByNameMap;
      var entry = cache.get(name);

      if (!entry) {
        entry = [];
        cache.set(name, entry);
      }

      entry.splice(entry.indexOf(oldAttr), 1, newAttr); // Run jsdom hooks; roughly correspond to spec's "An attribute is set and an attribute is changed."

      element._attrModified(name, newAttr._value, oldAttr._value);

      return;
    }
  }
};

exports.getAttributeByName = function (element, name) {
  // https://dom.spec.whatwg.org/#concept-element-attributes-get-by-name
  if (element._namespaceURI === HTML_NS && element._ownerDocument._parsingMode === "html") {
    name = asciiLowercase(name);
  }

  var cache = element._attributesByNameMap;
  var entry = cache.get(name);

  if (!entry) {
    return null;
  }

  return entry[0];
};

exports.getAttributeByNameNS = function (element, namespace, localName) {
  // https://dom.spec.whatwg.org/#concept-element-attributes-get-by-namespace
  if (namespace === "") {
    namespace = null;
  }

  var attributeList = element._attributeList;

  for (var i = 0; i < attributeList.length; ++i) {
    var attr = attributeList[i];

    if (attr._namespace === namespace && attr._localName === localName) {
      return attr;
    }
  }

  return null;
}; // Both of the following functions implement https://dom.spec.whatwg.org/#concept-element-attributes-get-value.
// Separated them into two to keep symmetry with other functions.


exports.getAttributeValue = function (element, localName) {
  var attr = exports.getAttributeByNameNS(element, null, localName);

  if (!attr) {
    return "";
  }

  return attr._value;
};

exports.getAttributeValueNS = function (element, namespace, localName) {
  var attr = exports.getAttributeByNameNS(element, namespace, localName);

  if (!attr) {
    return "";
  }

  return attr._value;
};

exports.setAttribute = function (element, attr) {
  // https://dom.spec.whatwg.org/#concept-element-attributes-set
  if (attr._element !== null && attr._element !== element) {
    throw new DOMException("The attribute is in use.", "InUseAttributeError");
  }

  var oldAttr = exports.getAttributeByNameNS(element, attr._namespace, attr._localName);

  if (oldAttr === attr) {
    return attr;
  }

  if (oldAttr !== null) {
    exports.replaceAttribute(element, oldAttr, attr);
  } else {
    exports.appendAttribute(element, attr);
  }

  return oldAttr;
};

exports.setAttributeValue = function (element, localName, value, prefix, namespace) {
  // https://dom.spec.whatwg.org/#concept-element-attributes-set-value
  if (prefix === undefined) {
    prefix = null;
  }

  if (namespace === undefined) {
    namespace = null;
  }

  var attribute = exports.getAttributeByNameNS(element, namespace, localName);

  if (attribute === null) {
    var newAttribute = attrGenerated.createImpl([], {
      namespace: namespace,
      namespacePrefix: prefix,
      localName: localName,
      value: value
    });
    exports.appendAttribute(element, newAttribute);
    return;
  }

  exports.changeAttribute(element, attribute, value);
};

exports.setAnExistingAttributeValue = function (attribute, value) {
  if (attribute._element === null) {
    attribute._value = value;
  }

  exports.changeAttribute(attribute._element, attribute, value);
};

exports.removeAttributeByName = function (element, name) {
  // https://dom.spec.whatwg.org/#concept-element-attributes-remove-by-name
  var attr = exports.getAttributeByName(element, name);

  if (attr !== null) {
    exports.removeAttribute(element, attr);
  }

  return attr;
};

exports.removeAttributeByNameNS = function (element, namespace, localName) {
  // https://dom.spec.whatwg.org/#concept-element-attributes-remove-by-namespace
  var attr = exports.getAttributeByNameNS(element, namespace, localName);

  if (attr !== null) {
    exports.removeAttribute(element, attr);
  }

  return attr;
};

exports.copyAttributeList = function (sourceElement, destElement) {
  // Needed by https://dom.spec.whatwg.org/#concept-node-clone
  var _iterator = _createForOfIteratorHelper(sourceElement._attributeList),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var sourceAttr = _step.value;
      var destAttr = attrGenerated.createImpl([], {
        namespace: sourceAttr._namespace,
        namespacePrefix: sourceAttr._namespacePrefix,
        localName: sourceAttr._localName,
        value: sourceAttr._value
      });
      exports.appendAttribute(destElement, destAttr);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

exports.attributeListsEqual = function (elementA, elementB) {
  // Needed by https://dom.spec.whatwg.org/#concept-node-equals
  var listA = elementA._attributeList;
  var listB = elementB._attributeList;

  if (listA.length !== listB.length) {
    return false;
  }

  var _loop = function _loop(i) {
    var attrA = listA[i];

    if (!listB.some(function (attrB) {
      return equalsA(attrB);
    })) {
      return {
        v: false
      };
    }

    function equalsA(attrB) {
      return attrA._namespace === attrB._namespace && attrA._localName === attrB._localName && attrA._value === attrB._value;
    }
  };

  for (var i = 0; i < listA.length; ++i) {
    var _ret = _loop(i);

    if (typeof _ret === "object") return _ret.v;
  }

  return true;
};

exports.attributeNames = function (element) {
  // Needed by https://dom.spec.whatwg.org/#dom-element-getattributenames
  return element._attributeList.map(function (a) {
    return a._qualifiedName;
  });
};

exports.hasAttributes = function (element) {
  // Needed by https://dom.spec.whatwg.org/#dom-element-hasattributes
  return element._attributeList.length > 0;
};